export default __webpack_public_path__ + "scripts/resource/d66e849f5c1d539807b38a11bb8600bd.svg";